import '@babel/polyfill'
/* global EventBus */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Register from './components/Registration/Register'

require('./unsupported')
require('./bootstrap')

window.EventBus = new Vue()

Vue.use(VueRouter)
Vue.component('register', Register)
Vue.component('basic-form', require('./components/Global/BasicForm').default)
Vue.component('search-accounts', require('./components/Global/SearchAccounts').default)

new Vue({
    el: '#app',

    methods: {
        appClick () {
            EventBus.$emit('AppClick', event)
        }
    }
})
